import { Container } from "react-bootstrap";

const ProFormaExitScreen = () => {
    return(
        <Container fluid="md py-5">
            <div className="text-center">
                <h1>Dziękujemy za złożenie zamówienia!</h1>
                <p className="lead">Wkrótce wyślemy do Ciebie fakturę pro-forma</p>
            </div>
        </Container>
    )
}
export default ProFormaExitScreen;